module.exports = __webpack_public_path__ + "img/1483365425.b77c06a5.jpg";